// Fotos de reseñas limitadas a recursos controlados por la aplicación.
export interface Review {
  id: number;
  productId: number;
  author: string;
  avatar: string;
  rating: number;
  date: string;
  title: string;
  comment: string;
  verified: boolean;
  helpful: number;
  photos?: string[];
}

export const reviews: Review[] = [
  {
    id: 1,
    productId: 1,
    author: 'María García',
    avatar: 'MG',
    rating: 5,
    date: '2026-02-15',
    title: 'Increíble aroma y frescura',
    comment: 'La mezcla de hierbas es espectacular. Se nota que son orgánicas de verdad, el aroma al abrir el tarro es maravilloso. Las uso a diario en mis ensaladas y sopas.',
    verified: true,
    helpful: 12,
    photos: [],
  },
  {
    id: 2,
    productId: 1,
    author: 'Carlos Ruiz',
    avatar: 'CR',
    rating: 4,
    date: '2026-01-28',
    title: 'Muy buena calidad',
    comment: 'Excelente producto, las hierbas están muy bien conservadas. Le doy 4 estrellas porque el envase podría ser un poco más grande para el precio.',
    verified: true,
    helpful: 8,
  },
  {
    id: 3,
    productId: 1,
    author: 'Ana López',
    avatar: 'AL',
    rating: 5,
    date: '2026-02-10',
    title: 'Repito sin duda',
    comment: 'Ya es la tercera vez que compro esta mezcla. La calidad es constante y el sabor que aporta a los platos es inigualable. Totalmente recomendable.',
    verified: true,
    helpful: 15,
  },
  {
    id: 16,
    productId: 1,
    author: 'Fernando Castillo',
    avatar: 'FC',
    rating: 3,
    date: '2026-01-20',
    title: 'Bien pero esperaba más',
    comment: 'Las hierbas son buenas pero el tarro venía medio vacío. El sabor es correcto, aunque he probado mezclas más aromáticas.',
    verified: false,
    helpful: 3,
  },
  {
    id: 4,
    productId: 2,
    author: 'Pedro Martínez',
    avatar: 'PM',
    rating: 5,
    date: '2026-03-20',
    title: 'El mejor jengibre que he probado',
    comment: 'Uso este jengibre para hacer té todas las mañanas. El sabor es intenso y puro, se nota la diferencia con los de supermercado. Muy recomendable.',
    verified: true,
    helpful: 20,
    photos: [],
  },
  {
    id: 5,
    productId: 2,
    author: 'Laura Sánchez',
    avatar: 'LS',
    rating: 4,
    date: '2026-02-05',
    title: 'Buen producto, envío rápido',
    comment: 'El jengibre tiene un sabor muy auténtico. Lo uso para cocina asiática y queda perfecto. El envío fue muy rápido, en 2 días lo tenía en casa.',
    verified: true,
    helpful: 6,
  },
  {
    id: 17,
    productId: 2,
    author: 'Raquel Ortega',
    avatar: 'RO',
    rating: 5,
    date: '2026-03-15',
    title: 'Perfecto para smoothies',
    comment: 'Añado una cucharadita a mis smoothies matutinos y el sabor es increíble. Muy fino y sin grumos. Calidad premium de verdad.',
    verified: true,
    helpful: 9,
  },
  {
    id: 6,
    productId: 3,
    author: 'Roberto Fernández',
    avatar: 'RF',
    rating: 5,
    date: '2026-03-18',
    title: 'Set completo y de calidad',
    comment: 'Este set de especias indias es fantástico. Cada especia tiene un aroma y color vibrante. Perfecto para preparar curry auténtico en casa.',
    verified: true,
    helpful: 18,
    photos: [],
  },
  {
    id: 7,
    productId: 3,
    author: 'Isabel Torres',
    avatar: 'IT',
    rating: 5,
    date: '2026-02-22',
    title: 'Regalo perfecto',
    comment: 'Lo compré como regalo para mi madre que adora la cocina india y le encantó. La presentación es preciosa y las especias son de primera calidad.',
    verified: true,
    helpful: 11,
  },
  {
    id: 8,
    productId: 3,
    author: 'Diego Moreno',
    avatar: 'DM',
    rating: 4,
    date: '2026-01-30',
    title: 'Muy buenas especias',
    comment: 'Las especias son auténticas y de gran calidad. La cúrcuma tiene un color precioso y el comino es muy aromático. Solo echo en falta que incluyera cardamomo.',
    verified: false,
    helpful: 5,
  },
  {
    id: 18,
    productId: 3,
    author: 'Lucía Romero',
    avatar: 'LR',
    rating: 2,
    date: '2026-01-15',
    title: 'Esperaba más variedad',
    comment: 'Las especias que vienen son buenas, pero para el precio esperaba más variedad. Faltan algunas básicas como el garam masala.',
    verified: true,
    helpful: 4,
  },
  {
    id: 9,
    productId: 4,
    author: 'Elena Navarro',
    avatar: 'EN',
    rating: 5,
    date: '2026-03-12',
    title: 'Albahaca con sabor real',
    comment: 'Por fin una albahaca seca que sabe a albahaca de verdad. La uso en pizzas, pastas y salsas. El aroma es increíble, como si fuera fresca.',
    verified: true,
    helpful: 14,
    photos: [],
  },
  {
    id: 10,
    productId: 4,
    author: 'Javier Díaz',
    avatar: 'JD',
    rating: 4,
    date: '2026-02-15',
    title: 'Buena relación calidad-precio',
    comment: 'La albahaca tiene muy buen sabor y aroma. El tarro es de buen tamaño y el precio es justo para la calidad que ofrece.',
    verified: true,
    helpful: 7,
  },
  {
    id: 19,
    productId: 4,
    author: 'Marta Iglesias',
    avatar: 'MI',
    rating: 5,
    date: '2026-04-01',
    title: 'La mejor albahaca seca',
    comment: 'He probado muchas marcas y esta es sin duda la mejor. El color verde intenso se mantiene y el sabor es extraordinario. La uso para todo.',
    verified: true,
    helpful: 10,
  },
  {
    id: 11,
    productId: 5,
    author: 'Sofía Herrera',
    avatar: 'SH',
    rating: 5,
    date: '2026-03-08',
    title: 'Pimienta excepcional',
    comment: 'Los granos de pimienta son grandes y aromáticos. Al molerlos el aroma llena toda la cocina. Sin duda la mejor pimienta que he comprado.',
    verified: true,
    helpful: 16,
  },
  {
    id: 12,
    productId: 5,
    author: 'Miguel Ángel Vega',
    avatar: 'MV',
    rating: 5,
    date: '2026-02-20',
    title: 'Calidad premium de verdad',
    comment: 'Se nota que es pimienta de calidad superior. El sabor es robusto pero no agresivo. Perfecta para carnes y guisos. Muy contento con la compra.',
    verified: true,
    helpful: 9,
    photos: [],
  },
  {
    id: 20,
    productId: 5,
    author: 'Alejandro Ruiz',
    avatar: 'AR',
    rating: 3,
    date: '2026-01-28',
    title: 'Buena pero no excepcional',
    comment: 'La pimienta es buena, tiene buen sabor. Pero he probado otras marcas premium que me han gustado más. El precio es un poco alto para lo que ofrece.',
    verified: false,
    helpful: 2,
  },
  {
    id: 13,
    productId: 6,
    author: 'Carmen Jiménez',
    avatar: 'CJ',
    rating: 5,
    date: '2026-04-05',
    title: 'Aromas del Mediterráneo en casa',
    comment: 'Este set es una maravilla. El romero y el tomillo son espectaculares. Los uso para hacer focaccia y pollo al horno. Resultado siempre perfecto.',
    verified: true,
    helpful: 22,
    photos: [],
  },
  {
    id: 14,
    productId: 6,
    author: 'Antonio Ramírez',
    avatar: 'AR',
    rating: 4,
    date: '2026-03-01',
    title: 'Muy buen set de hierbas',
    comment: 'Las hierbas son de excelente calidad y la presentación es muy bonita. El orégano y el romero son mis favoritos. Ideal para regalar.',
    verified: true,
    helpful: 10,
  },
  {
    id: 15,
    productId: 6,
    author: 'Patricia Molina',
    avatar: 'PM',
    rating: 5,
    date: '2026-02-08',
    title: 'No puedo vivir sin este set',
    comment: 'Desde que descubrí este set de hierbas mediterráneas no puedo cocinar sin ellas. La lavanda para postres es un descubrimiento. Calidad insuperable.',
    verified: true,
    helpful: 19,
  },
  {
    id: 21,
    productId: 6,
    author: 'Gonzalo Prieto',
    avatar: 'GP',
    rating: 4,
    date: '2026-01-12',
    title: 'Excelente para barbacoas',
    comment: 'Uso estas hierbas para marinar carnes antes de la barbacoa y el resultado es espectacular. El romero y el tomillo le dan un toque increíble.',
    verified: true,
    helpful: 13,
  },
];
